<template>
  <div class="bg">
    <div class="login">
      <el-card class="box-card">
        <h1>{{getLoginTitle}}</h1>
        <el-form ref="form" :model="form" @keyup.enter.native="onSubmit" label-width="80px">
          <el-input v-model="form.name" prefix-icon="el-icon-user-solid"></el-input>
          <el-input v-model="form.password" show-password prefix-icon="el-icon-lock"></el-input>
          <el-button type="primary" @click="onSubmit" round>登录</el-button>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .bg
    width: 100vw
    height: 100vh
    background-image: url("../../../assets/bg.png")
    background-size: 100%
    background-repeat: no-repeat
    .el-card, .el-card__body
      background-color: #2b2b2b

    .login
      width: 500px
      float: right
      margin-top: 150px
      margin-right: 60px
      h1
        padding-bottom: 20px
        color: #fff
        text-align: center
      .el-input, button
        margin-bottom: 42px
        
    .el-card
      border: 1px solid #2b2b2b
      .el-input--prefix .el-input__inner
        padding-left: 40px
      .el-input__icon
        font-size: 30px
      .el-button
        width: 100%
</style>

<script>
import store from "@/store";
import config from "@/config";

export default {
  data() {
    return {
      form: {
        name: "",
        password: ""
      },
      languageMap:{}
    };
  },
  created() {
    this.keyupEnter();
  },
  computed: {
    getLoginTitle() {
      return store.state.config.login.title || 'MRLight';
    }
  },
  mounted() {

    this.init();
  },
  methods: {
    init(){  //初始化
    
    },
 getCookie(name) {  //获取cookie
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    keyupEnter() {
      document.onkeydown = e => {
        let body = document.getElementsByTagName("body")[0];
        if (
          e.keyCode === 13 &&
          e.target.baseURI.match(/inputbook/) &&
          e.target === body
        ) {
          console.log("enter");
          this.onSubmit();
        }
      };
    },
    onSubmit() {
      let url =  config.url + "SysUserController/login.action";
      let param = {
        "userName": this.form.name,
	      "password": this.form.password,
        "loginChannel": "1"
      }
      store.state.token = this.form.name;
      this.$http
        .post(url, param)
        .then(res => {
          let data = res.data;
          console.log(data)
          if(data.resultCode == 200){
            store.state.token = this.form.name;
            store.state.sysRole = data.data.sysRole;

            sessionStorage.setItem("userName", data.data.userName);
            sessionStorage.setItem("sysRole", data.data.sysRole);
            sessionStorage.setItem("token",data.data.token);
            // this.setCookie("weackCurrentChangeGroup",'');

            this.$router.push({ path: "/back/classify" });
          }
          else {
            this.$message.error(data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("登陆失败");
        });
    },
      setCookie(name, value) {  //存入cookie
        var time = 24* 300 * 60 * 60 * 1000;
        var exp = new Date();
        var expires = new Date(exp.getTime() + time);
        document.cookie=name+'=' + escape(value) + ';expires='+expires.toGMTString()+';path=/';
     }
  }
};
</script>
